<div class="manage-payment-form-container">
  <div class="bolt-container bolt-space-bottom-2xl">
    <bolt-progress-bar appFocusOnInit arialabel="cancel automatic payments progress value is 100%" value="100" class="progress-bar-container to-container"></bolt-progress-bar>
    <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Cancel automatic payment: confirmation</h1>

    @if (!apiCallSuccessful) {
      <div class="bolt-space-bottom-2xl">
        <bolt-notification type="error" id="error-notification">
          <is-interpolate [text]="apiFailureMessage"></is-interpolate>
        </bolt-notification>
      </div>
    } @else {
      <div class="bolt-space-bottom-2xl">
        <bolt-notification type="success">
          {{ confirmationMessage }}
        </bolt-notification>
      </div>
      @if (amountDueNotExists) {
        <div>
          <app-payment-sub-header><strong>Next Steps</strong></app-payment-sub-header>
          <div class="main-contents">
            <div class="bolt-row bolt-space-bottom-xl">
              <div class="bolt-col">
                <strong>Make a payment by:</strong>
              </div>
              <div class="bolt-col">
                {{ amountDueByDate }}
              </div>
            </div>
            <div class="bolt-row bolt-row bolt-space-bottom-2xl">
              <div class="bolt-col">
                <strong>Amount due:</strong>
              </div>
              <div class="bolt-col">
                {{ dueAmount }}
              </div>
            </div>
          </div>
        </div>
      }
      @if (!isLifeOnlyAccount) {
        <p class="refund-message bolt-space-bottom-2xl">
          {{ enrollMessage }}
        </p>
      }
      <app-payment-sub-header>Confirmation details</app-payment-sub-header>
      <div class="main-contents">
        <div class="bolt-row bolt-space-bottom-xl">
          <div class="bolt-col">
            <strong>Account number:</strong>
          </div>
          <div class="bolt-col">
            {{ billingAccountNumber }}
          </div>
        </div>
        <div class="bolt-row bolt-row bolt-space-bottom-2xl">
          <div class="bolt-col">
            <strong>Submitted date:</strong>
          </div>
          <div class="bolt-col">
            {{ formattedCurrentDate }}
          </div>
        </div>
      </div>
      @if (amountDueExists) {
        <app-payment-sub-header>Outstanding payment due</app-payment-sub-header>
        <div class="main-contents">
          <p>{{ outstandingdueMessage }}</p>
        </div>
      }
    }
  </div>

  @if (amountDueExists) {
    <bolt-button-bar>
      <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
      <is-button id="secondary-button" slot="back" (click)="secondayNavigation(secondaryButton)">{{ secondaryButton.label }}</is-button>
      @if (upNextLabel) {
        <is-button id="make-a-payment-button" slot="forward" (click)="onContinue()" [type]="solid">
          {{ upNextLabel }}
        </is-button>
      }
    </bolt-button-bar>
  } @else {
    <bolt-button-bar>
      <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
      <is-button id="secondary-button" slot="forward" (click)="secondayNavigation(secondaryButton)">{{ secondaryButton.label }}</is-button>
    </bolt-button-bar>
  }
</div>
